export default "__VITE_ASSET__052b3b44__"